import { useSelector } from 'react-redux';
import { opt } from 'ts-opt';
import { simpleTableSelector } from 'utils/tables';

/**
 * Checks whether the given mating table still has persisted column settings.
 *
 * @param tableModule Table module key used by the shared table settings store.
 * @param tableCode Table code used by the shared table settings store.
 * @returns `true` when the table has full settings available.
 */
export const useTableSettingsExists = (tableModule: string, tableCode: string): boolean => {
  const tableConfig = useSelector(simpleTableSelector.tableConfig(tableModule, tableCode));
  const columnSettings = opt(tableConfig).prop('gridSettings').findIn(x => x.isDefault).prop('gridSettings').prop('columnSettings');
  return columnSettings.isFull;
};